import React from 'react';
import { ErrorMessage, Grid, Header1Text, Pager } from 'ui-toolkit';
import { IVendorPayoffsData } from '../../../types/vendorDashboard/IVendorPayoffs';
import { eTitleSearchStatus, vendorInitialStatuses } from '../../../types/order/title/eTitleSearchStatus';
import { ISearchOrdersSettingsData } from '../../../types/vendorDashboard/ISearchOrdersSettingsData';
import { VendorDashTabs } from '../../../components/vendorDashboard/VendorDashTabs';
import { VendorOrdersFilter } from '../../../components/vendorDashboard/VendorOrdersFilter';
import { OrderSearchForm } from '../../../components/vendorDashboard/comments/OrderSearchForm';
import { PayoffsTable } from '../../../components/vendorDashboard/payoffs/PayoffsTable';
import { ISearchOrdersSpecificationData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export interface IVendorPayoffsPageProps {
  pageError?: string;
  payoffs: IVendorPayoffsData;
  searchSettings: ISearchOrdersSettingsData;
  loadingPayoffs: boolean;
  onFilterPayoff: (status: eTitleSearchStatus[]) => void;
  onPageSizeUpdate: (pageSize: number) => void;
  onPageUpdate: (page: number) => void;
  onSearchPayoff: (value: ISearchOrdersSpecificationData) => void;
}

export const VendorPayoffsPage: React.FC<IVendorPayoffsPageProps> = ({
  pageError,
  payoffs,
  searchSettings,
  loadingPayoffs,
  onFilterPayoff,
  onPageSizeUpdate,
  onPageUpdate,
  onSearchPayoff,
}) => {
  return (
    <>
      <ErrorMessage message={pageError} />
      <VendorDashTabs
        activeTabIndex={1}
        prefix={<Header1Text>Orders</Header1Text>}
        suffix={
          <VendorOrdersFilter
            onFilterPayoff={onFilterPayoff}
            statuses={searchSettings.statuses}
            filterOptions={vendorInitialStatuses}
            defaultStatuses={vendorInitialStatuses}
          />
        }
      >
        <Grid>
          <OrderSearchForm onSearchOrder={onSearchPayoff} />
          <PayoffsTable payoffs={payoffs.payoffRequests} loading={loadingPayoffs} />
          <Pager
            onPageSizeChange={onPageSizeUpdate}
            onPageChange={onPageUpdate}
            pageSize={searchSettings.pageSize}
            page={searchSettings.page}
            total={payoffs.total}
            disabled={loadingPayoffs}
          />
        </Grid>
      </VendorDashTabs>
    </>
  );
};
